import { render, staticRenderFns } from "./videoBlock.vue?vue&type=template&id=1c2dfe2e&scoped=true&"
import script from "./videoBlock.vue?vue&type=script&lang=js&"
export * from "./videoBlock.vue?vue&type=script&lang=js&"
import style0 from "./videoBlock.vue?vue&type=style&index=0&id=1c2dfe2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2dfe2e",
  null
  
)

export default component.exports